<template>
  <div>
    <PageHeader :schema="$schemas.checkControl" />
    <PageContent>
      <DynamicFormPage
        :schema="$schemas.checkControl"
        :service="$api.checkControls"
      />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateCheckControl',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
